<template>
  <svg
    fill="inherit"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="orbit"
      :class="{ active: active }"
    >
      <path
        d="M13.9923 3.22329C14.1146 2.68471 13.7771 2.14368 13.229 2.0758C11.4202 1.85177 9.57748 2.1258 7.90323 2.87769C5.92376 3.76666 4.28716 5.27536 3.24042 7.17612C2.19368 9.07688 1.7936 11.2665 2.10056 13.4146C2.40753 15.5627 3.40487 17.5527 4.94208 19.0842C6.4793 20.6157 8.47295 21.6056 10.6222 21.9046C12.7714 22.2036 14.9596 21.7954 16.8564 20.7416C18.7533 19.6878 20.2559 18.0456 21.1375 16.0628C21.8831 14.3858 22.1503 12.5421 21.9196 10.7341C21.8496 10.1862 21.3074 9.85082 20.7692 9.97507V9.97507C20.2311 10.0993 19.9023 10.6365 19.9585 11.186C20.0999 12.5684 19.8792 13.97 19.31 15.2503C18.6047 16.8365 17.4026 18.1502 15.8851 18.9933C14.3676 19.8363 12.6171 20.1629 10.8977 19.9237C9.17836 19.6845 7.58344 18.8926 6.35367 17.6674C5.1239 16.4421 4.32602 14.8502 4.08045 13.1317C3.83488 11.4132 4.15494 9.6615 4.99234 8.1409C5.82973 6.62029 7.13901 5.41333 8.72258 4.70215C10.0007 4.12816 11.4015 3.90228 12.7845 4.03854C13.3341 4.0927 13.8701 3.76187 13.9923 3.22329V3.22329Z"
      />

      <g
        id="planet"
        :class="{ active: active }"
      >
        <path
          clip-rule="evenodd"
          d="M12.1564 9.03915C12.2009 9.06179 12.2551 9.10942 12.2785 9.14763C12.3024 9.18536 12.4002 9.49242 12.499 9.83815C12.7148 10.5961 12.7961 10.7739 13.0248 10.9895C13.259 11.2107 13.4211 11.2824 14.1527 11.4899C14.4861 11.5843 14.7929 11.6819 14.8342 11.7069C14.9224 11.7593 14.9619 11.8144 14.9908 11.9267C15.0271 12.0687 14.9523 12.2413 14.8255 12.3083C14.7989 12.3224 14.5073 12.4111 14.1771 12.5054C13.8469 12.5998 13.5309 12.6946 13.4753 12.7163C13.3353 12.77 13.1089 12.9252 12.9931 13.0469C12.7709 13.2809 12.7079 13.4242 12.4912 14.1869C12.3915 14.5374 12.3038 14.81 12.2776 14.8515C12.1467 15.0581 11.8074 15.0468 11.7031 14.8322C11.6843 14.794 11.5929 14.4954 11.4997 14.1695C11.4064 13.8431 11.3068 13.5238 11.2788 13.4591C11.1318 13.1271 10.8604 12.8611 10.5265 12.7224C10.4664 12.6979 10.1541 12.6017 9.83262 12.5092C9.51114 12.4172 9.22733 12.3328 9.20208 12.322C9.07762 12.2682 9 12.1456 9 12.0022C9 11.8847 9.02986 11.8177 9.11711 11.739C9.19197 11.6715 9.15937 11.6824 9.83951 11.4899C10.6583 11.2579 10.7231 11.2282 10.995 10.9508C11.2296 10.7112 11.2852 10.589 11.4988 9.83815C11.5901 9.51647 11.6696 9.23772 11.6751 9.21885C11.6921 9.16084 11.7945 9.05471 11.8616 9.02594C11.952 8.98726 12.0641 8.99198 12.1564 9.03915Z"
          fill-rule="evenodd"
        />
      </g>
    </g>
    <g
      id="star"
      :class="{ active: active }"
    >
      <path
        clip-rule="evenodd"
        d="M12.2607 7.06524C12.3349 7.10298 12.4252 7.18237 12.4642 7.24605C12.5041 7.30894 12.6671 7.8207 12.8316 8.39692C13.1914 9.6602 13.3269 9.95657 13.708 10.3158C14.0984 10.6845 14.3686 10.804 15.5879 11.1499C16.1436 11.3071 16.6548 11.4698 16.7237 11.5115C16.8707 11.5988 16.9365 11.6907 16.9847 11.8778C17.0452 12.1145 16.9204 12.4022 16.7092 12.5138C16.6648 12.5374 16.1788 12.6852 15.6284 12.8424C15.0781 12.9996 14.5515 13.1576 14.4589 13.1938C14.2254 13.2834 13.8481 13.542 13.6552 13.7449C13.2848 14.1348 13.1799 14.3737 12.8186 15.6449C12.6525 16.229 12.5063 16.6833 12.4627 16.7525C12.2446 17.0968 11.6789 17.078 11.5052 16.7203C11.4738 16.6566 11.3215 16.159 11.1661 15.6158C11.0107 15.0718 10.8447 14.5396 10.798 14.4319C10.553 13.8785 10.1007 13.4351 9.54422 13.204C9.44395 13.1631 8.92348 13.0028 8.38769 12.8487C7.85191 12.6954 7.37889 12.5547 7.33679 12.5366C7.12937 12.447 7 12.2426 7 12.0036C7 11.8079 7.04976 11.6962 7.19519 11.565C7.31995 11.4525 7.26561 11.4706 8.39918 11.1499C9.7639 10.7631 9.87182 10.7136 10.3249 10.2514C10.7161 9.85201 10.8087 9.64841 11.1646 8.39692C11.3169 7.86079 11.4493 7.3962 11.4585 7.36475C11.4868 7.26806 11.6575 7.09118 11.7693 7.04323C11.92 6.97877 12.1068 6.98663 12.2607 7.06524Z"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface AIIconProps {
  active?: boolean;
}

defineProps<AIIconProps>();
</script>

<style lang="scss" scoped>
#orbit {
  transform-origin: center;

  &.active {
    animation: rotate-orbit 2s ease-in-out infinite;
  }
}

#planet {
  transform: translate(28%, -25%);
  transform-origin: center;

  &.active {
    animation: rotate-planet 2s ease-in-out infinite;
  }
}

#star {
  transform-origin: center;

  &.active {
    animation: pulse-star 2s ease-in-out infinite;
  }
}

@keyframes rotate-orbit {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}

@keyframes rotate-planet {
  from {
    transform: translate(28%, -25%) rotate(0deg);
  }

  to {
    transform: translate(28%, -25%) rotate(360deg);
  }
}

@keyframes pulse-star {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.6);
  }

  50% {
    transform: scale(1);
  }
}
</style>
